import React from "react";
import { colors, spacing, textStyles } from "@/ui/tokens";

export interface ToolSectionHeaderProps {
  icon: React.ReactElement<{ style?: React.CSSProperties }>;
  label: string;
  /** Use muted style for secondary sections (Tags, Notes) */
  muted?: boolean;
  /** Reduce bottom margin from spacing[4] to spacing[2] */
  compact?: boolean;
  /** Override icon color (defaults to product/muted based on variant) */
  iconColor?: string;
}

export function ToolSectionHeader({
  icon,
  label,
  muted,
  compact,
  iconColor,
}: ToolSectionHeaderProps) {
  const styledIcon = React.cloneElement(icon, {
    style: {
      fontSize: muted ? 16 : 18,
      color: iconColor || (muted ? colors.text.muted : colors.action.product),
    },
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: spacing[2],
        marginBottom: compact || muted ? spacing[2] : spacing[4],
      }}
    >
      {styledIcon}
      <span
        style={
          muted
            ? { ...textStyles.caption, color: colors.text.muted }
            : { ...textStyles.body2, fontWeight: 600 }
        }
      >
        {label}
      </span>
    </div>
  );
}
